(function () {
  document.documentElement.classList.add('js');

  function initReserve(root) {
    if (!root || root.dataset.profundaInit === 'true') return;
    root.dataset.profundaInit = 'true';

    var openBtn = root.querySelector('[data-profunda-open-form]');
    var formWrap = root.querySelector('[data-profunda-form-wrap]');
    if (!openBtn || !formWrap) return;

    var forceOpen = formWrap.dataset.open === 'true';

    function openForm() {
      if (formWrap.classList.contains('is-open')) return;
      formWrap.classList.add('is-open');
      openBtn.hidden = true;
      setTimeout(function () {
        var first = root.querySelector('[data-profunda-first-field]');
        if (first) first.focus({ preventScroll: true });
      }, 450);
    }

    if (forceOpen) {
      formWrap.classList.add('is-open');
      openBtn.hidden = true;
    } else {
      openBtn.hidden = false;
      openBtn.addEventListener('click', openForm);
    }

    document.querySelectorAll('[data-profunda-reserve-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        setTimeout(openForm, 600);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-profunda-reserve]').forEach(initReserve);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-profunda-reserve]');
    if (root) {
      root.dataset.profundaInit = 'false';
      initReserve(root);
    }
  });
})();
